import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHero, Loading } from "@/components/site/ui";
import { Reveal } from "@/components/brand";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Policies() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/policies").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <div>
      <PageHero eyebrow="The Fine Print" title="Policies" subtitle="Clear, fair, and here to protect the experience for everyone." compact />
      <div className="max-w-3xl mx-auto px-6 py-16">
        {items === null ? <Loading /> : (
          <Reveal>
            <Accordion type="single" collapsible className="space-y-3">
              {items.map((p) => (
                <AccordionItem key={p.id} value={p.id} className="glass rounded-lg border-gold/15 px-5">
                  <AccordionTrigger className="font-serif text-xl hover:no-underline hover:text-gold" data-testid={`policy-${p.id}`}>{p.title}</AccordionTrigger>
                  <AccordionContent className="text-sm text-muted-foreground leading-relaxed">{p.body}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        )}
      </div>
    </div>
  );
}
